import { useState, useEffect } from 'react';
import { Container, Title, Select, NumberInput, Button, Alert, Loader, Stack, Paper } from '@mantine/core';
import { useForm } from '@mantine/form';
import api from '@/config/api';

export default function W4Update() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const form = useForm({
    initialValues: {
      filing_status: 'single',
      additional_withholding: 0,
      exemptions: 1,
    },
  });

  useEffect(() => {
    api.get('/payroll/my/w4')
      .then(res => { if (res.data) form.setValues(res.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (values: typeof form.values) => {
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      await api.put('/payroll/my/w4', values);
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to update');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Loader mx="auto" mt="xl" />;

  return (
    <Container size="sm">
      <Title order={2} mb="lg">W-4 Information</Title>
      {error && <Alert color="red" mb="md">{error}</Alert>}
      {success && <Alert color="green" mb="md">W-4 updated successfully.</Alert>}
      <Paper p="lg" withBorder>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Stack>
            <Select label="Filing Status" data={[
              { value: 'single', label: 'Single' },
              { value: 'married', label: 'Married Filing Jointly' },
              { value: 'head_of_household', label: 'Head of Household' },
            ]} {...form.getInputProps('filing_status')} />
            <NumberInput label="Additional Withholding" min={0} prefix="$" {...form.getInputProps('additional_withholding')} />
            <NumberInput label="Exemptions" min={0} max={20} {...form.getInputProps('exemptions')} />
            <Button type="submit" loading={saving}>Update W-4</Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
